// extracted by mini-css-extract-plugin
export var phone = "_3f-0";
export var phoneDragging = "_3f-1";